// removed by extract-text-webpack-plugin
module.exports = {"buyMoreQuestionsModalOverlayClassName":"_2wNMlyV-xG8UCj9rvy4YOT","buyMoreQuestionsModalContent":"_2JXuCQqZzynryW8e_EMs23","buyMoreQuestionsModal1":"_2m3X6uJ9XqzWoP1QJFdlTO","buyMoreQuestionsModal2":"_20zBq2HI8obtmhpC8yNavX","buyAnotherCountOfQuestionsWrapper":"_3pbSnQqaBpeF-Bm0UJQmxa","buyAnotherCountOfQuestionsButton":"_36n_ZCEypDN6UMpKMv-vtU","showButton":"SNDptv27zfY8AiEVE-BMh","hideButton":"_2sGe1AbaUQnTzjzxT3mmk6","actionIcon":"_2wW5xbLY86OwMz6l_pDl9Q","buyMoreQuestionsModalBody":"_1cVVvk4upekw3i1ov2F5aP","clientContactForm":"_2m75WgA-jxnzGlBETlOUfW"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/BuyMoreQuestions/BuyMoreQuestions.scss
// module id = 1822
// module chunks = 0